"use client";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { PageMedia } from "../../types";

/** Supporting quotes are separate editable blocks inside any layout container. */
export function PageSupportingTestimonial({
  name,
  quote,
  photo,
}: {
  name: string;
  quote: string;
  photo?: PageMedia;
}) {
  return (
    <Box
      component="figure"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: "20px 18px",
        m: 0,
        bgcolor: "common.white",
        border: "1px solid",
        borderColor: "dream.borderColor",
        borderRadius: "20px",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Box
        data-testid="supporting-testimonial-avatar"
        sx={{
          width: 48,
          height: 48,
          mb: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          overflow: "hidden",
          borderRadius: "50%",
          bgcolor: "#e8f2ff",
          color: "primary.main",
          fontSize: "1.1rem",
          fontWeight: 700,
        }}
      >
        {photo ? (
          <Box
            component="img"
            src={photo.url}
            alt={name.trim()}
            width={48}
            height={48}
            sx={{ borderRadius: "50%", objectFit: "cover" }}
          />
        ) : (
          name.trim().charAt(0).toUpperCase()
        )}
      </Box>
      <Typography
        component="blockquote"
        sx={{
          color: "dream.grayMediumDark",
          fontSize: ".92rem",
          fontStyle: "italic",
          lineHeight: 1.5,
          m: 0,
          mb: "10px",
          textAlign: "center",
        }}
      >
        &ldquo;{quote}&rdquo;
      </Typography>
      <Typography
        component="figcaption"
        sx={{ color: "dream.grayDark", fontSize: ".85rem", fontWeight: 700, textAlign: "center" }}
      >
        {name}
      </Typography>
    </Box>
  );
}
